import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "check-all-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.5303 6.46967C17.8232 6.76256 17.8232 7.23744 17.5303 7.53033L13.0303 12.0303C12.7374 12.3232 12.2626 12.3232 11.9697 12.0303C11.6768 11.7374 11.6768 11.2626 11.9697 10.9697L16.4697 6.46967C16.7626 6.17678 17.2374 6.17678 17.5303 6.46967Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.46967 11.4697C2.76256 11.1768 3.23744 11.1768 3.53033 11.4697L8.53033 16.4697C8.82322 16.7626 8.82322 17.2374 8.53033 17.5303C8.23744 17.8232 7.76256 17.8232 7.46967 17.5303L2.46967 12.5303C2.17678 12.2374 2.17678 11.7626 2.46967 11.4697Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.5303 8.46967C21.8232 8.76256 21.8232 9.23744 21.5303 9.53033L13.5303 17.5303C13.2374 17.8232 12.7626 17.8232 12.4697 17.5303L6.46967 11.5303C6.17678 11.2374 6.17678 10.7626 6.46967 10.4697C6.76256 10.1768 7.23744 10.1768 7.53033 10.4697L13 15.9393L20.4697 8.46967C20.7626 8.17678 21.2374 8.17678 21.5303 8.46967Z"
    }, null, -1)
  ])))
}
export default { render: render }